import VueTimeago from 'vue-timeago';

export default (instance: any) => {
  instance.use(VueTimeago, {
    name: 'Timeago',
    locale: 'en',
  });
};
